import React, { useEffect, useState } from 'react'
import queryString from "utils/queryString";
import { toast } from 'react-toastify';
import Loading from 'components/Loading';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getUserMissions } from 'services/mission.routes';
import UserMissionTable from './UserMissionTable';

export default function UserMissions() {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [userMissions, setUserMissions] = useState([]);
    const [searchInfo, setSearchInfo] = useState({ all: true });
    const [trigger, setTrigger] = useState(null);

    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        if (name === "hasDone" || name === "needToApprove" || name === "hasApprove") {
            setSearchInfo({ ...searchInfo, [name]: checked });
        } else if (name === "all") {
            setSearchInfo(checked ? { [name]: checked } : { ...searchInfo, [name]: checked });
        }
        else
            setSearchInfo({ ...searchInfo, [name]: value });
    };

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            admin: 1,
            with_mission: 1,
            with_user: 1,
            need_to_approve: searchInfo?.all ? null : searchInfo?.needToApprove !== undefined ? +searchInfo?.needToApprove : null,
            has_done: searchInfo?.all ? null : searchInfo?.hasDone !== undefined ? +searchInfo?.hasDone : null,
            has_approve: searchInfo?.all ? null : searchInfo?.hasApprove !== undefined ? +searchInfo?.hasApprove : null,
        }
        getUserMissions(queryString(query), false, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setUserMissions((prev) => ([...prev, ...data.data]));
                } else {
                    setUserMissions(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                setHasMore(data.meta.next_cursor !== null);
            }
        })
    }, [page, trigger]);


    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    const onClearFilterClick = () => {
        setSearchInfo({ all: true })
        onFilterClick()
    }
    const onFilterClick = () => {
        if (page === 0) {
            setTrigger(Math.random());
        } else {
            setPage(0);
        }
        setCursor('');
    }

    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={userMissions.length} next={fetchMoreData} hasMore={hasMore}>
                <UserMissionTable data={userMissions} onFilterClick={onFilterClick} searchInfo={searchInfo} handleFilterChange={handleChange} onClearFilterClick={onClearFilterClick} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
